<template>
  <form @submit.prevent="onSubmit" class="clm-form__form">
    <a-layout :line-type="'create'" @go="goCreate" :title-text="titleText" @close="$emit('close')">
      <div v-if="!serverSuccess">
        <a-report :is-error="true" v-if="serverError">
          Внимание! {{messageText}}
        </a-report>
        <div class="clm-form__inputs-block">
          <auth-form-input
              @submit="onSubmit"
              :is-requared="true"
              :id="idPrefix + 'anr-pass'"
              :input-type="(showPassword) ? 'text' : 'password'"
              :input-name="'password'"
              :class-name="'password'"
              :placeholder="'Введите пароль'"
              :err-msg="(formPass1.length > 0) ? cPassErr : 'Пароль не указан'"
              :is-valid="cFormPassValid || cFormPassFirstValid"
              :is-invalid="formPassInvalid"
              :show-pass-btn="true"
              :is-visible="showPassword"
              @pass:show="showPassword = true"
              @pass:hide="showPassword = false"
              v-model="formPass1"
          >Новый пароль
          </auth-form-input>
          <auth-form-input
              @submit="onSubmit"
              :is-requared="true"
              :id="idPrefix + 'anr-pass2'"
              :input-type="(showPassword) ? 'text' : 'password'"
              :input-name="'password'"
              :class-name="'password'"
              :placeholder="'Повторно введите пароль'"
              :err-msg="(formPass2.length > 0) ? cPassErr : 'Повторный пароль не указан'"
              :is-valid="cFormPassValid"
              :is-invalid="formPassInvalid"
              :is-visible="showPassword"
              v-model="formPass2"
          >Повторите новый пароль
          </auth-form-input>
        </div>
        <div class="clm-form-btns">
          <a-submit-btn :is-disabled="!cFormValid" @action="onSubmit" :is-loading="formProcess">{{submitText}}</a-submit-btn>
        </div>
        <a-agreement>{{submitText}}</a-agreement>
      </div>
      <div v-else>
        <div class="clm-form-text">
          <div class="clm-form-text__title">
            Ваш пароль был успешно изменен.
          </div>
          <div class="clm-form-text__subtitle">
            <p>
              Пожалуйста, используйте ваш новый пароль для доступа к личному кабинету.
            </p>
          </div>
        </div>
        <div class="clm-form-btns">
          <a-submit-btn @action="goAuth">Войти</a-submit-btn>
        </div>
      </div>
    </a-layout>
  </form>
</template>

<script>
import aReport from "./a-report";
import aAgreement from "./a-agreement";
import aSubmitBtn from "./a-submit-btn";
import authFormInput from "../auth-form-input";
import aLayout from "./a-layout";

import validate from "../../../scripts/validate";
import createPassError from "../../../scripts/createPassError";

export default {
  name: "auth-form-new",
  components: {
    aReport,
    aAgreement,
    aSubmitBtn,
    authFormInput,
    aLayout
  },
  props: {
    idPrefix: String,
    pageParams: Object
  },
  emits: ['close', 'go:create', 'go:authNew'],
  data() {
    return {
      submitText: 'Сохранить новый пароль',
      titleText: 'Восстановление доступа',

      formPass1: '',
      formPass2: '',
      formPassInvalid: false,

      showPassword: false,

      formProcess: false,
      serverError: false,
      serverSuccess: false,
      messageText: '',
      defaultErr: 'Ошибка в работе сайта. Попробуйте еще раз.'
    }
  },
  computed: {
    cFormPassValid() {
      const valid = this.cFormPassFirstValid;
      return (valid && this.formPass1 === this.formPass2)
    },
    cFormPassFirstValid() {
      const params = this.pageParams.passPolicy;
      return validate('pass', this.formPass1, params)
    },
    cFormValid() {
      return this.cFormPassValid
    },
    cPassErr() {
      const pass1 = this.formPass1;
      const pass2 = this.formPass2;
      const params = this.pageParams.passPolicy;
      return createPassError(pass1, pass2, params)
    }
  },
  watch: {
    formPass1() {
      this.formPassInvalid = false;
    },
    formPass2() {
      this.formPassInvalid = false;
    }
  },
  methods: {
    goCreate() {
      this.$emit('go:create')
    },
    goAuth() {
      this.$emit('go:authNew', this.pageParams.startNewParam.USER_LOGIN)
    },
    onSubmit() {
      if (this.formProcess) {
        return null;
      }

      let noErr = true
      const pass1 = this.formPass1
      const pass2 = this.formPass2
      const passParams = this.pageParams.passPolicy;
      if (pass1 !== pass2 || !validate('pass', pass1, passParams)) {
        this.formPassInvalid = true;
        noErr = false;
      }

      if (noErr) {
        this.formProcess = true;
        this.$api.newPass({
          'USER_LOGIN': this.pageParams.startNewParam.USER_LOGIN,
          'USER_CHECKWORD': this.pageParams.startNewParam.USER_CHECKWORD,
          'USER_PASSWORD': this.formPass1,
          'USER_CONFIRM_PASSWORD': this.formPass2,
        }).then(data => {
          const response = data.data;
          if (response.status) {
            console.log('Успешная смена')
            this.serverError = false;
            this.serverSuccess = true;
          } else {
            if (response.errors.length > 0) {
              this.serverError = true
              this.messageText = response.errors.join('; ')
            } else {
              this.serverError = true
              this.messageText = this.defaultErr
            }
          }
          this.formProcess = false;
        }).catch(err => {
          console.error('Ajax err')
          console.log(err)
          this.serverError = true
          this.messageText = this.defaultErr
          this.formProcess = false;
        })
      }
    }
  }
}
</script>